import { useActions, useAtoZUrls, } from '@amzn/showtime';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import pushExternalUri from './ExternalLinking';
import LinkingConfig, { isRnwScreen } from './LinkingConfig';
const TAG = 'WebAppNavigation';
const Stack = createStackNavigator();
export default function WebAppNavigation({ navigationRef, placements }) {
    const { goBack, pushUri } = useActions();
    const { logout: logoutUri } = useAtoZUrls();
    const logout = () => pushExternalUri({ uri: logoutUri });
    const linking = LinkingConfig(placements);
    const screenPlacements = placements.filter(isRnwScreen);
    const screens = [];
    screenPlacements.forEach(({ id, title = 'Amazon A to Z', component: Component }) => {
        if (!Component) {
            return;
        }
        screens.push((React.createElement(Stack.Screen, { key: id, name: id, options: { title } }, () => (React.createElement(Component, { goBack: goBack, pushUri: pushUri, logout: logout, placements: placements })))));
    });
    if (screens.length === 0) {
        console.warn(`${TAG} We don't have any active placement! Check your configuration!`);
        return null;
    }
    return (React.createElement(NavigationContainer, { ref: navigationRef, linking: linking },
        React.createElement(Stack.Navigator, { screenOptions: { headerShown: false } }, screens)));
}
//# sourceMappingURL=WebAppNavigation.js.map